<template>
  <div class="finance-base-bill accounts-payable-bill">
    <div class="header">
      <div class="btn-container">
        <el-button
          type="primary"
          icon="el-icon-plus"
          v-if="curAuth.includes('addPayableOrder') && !isLockBill"
          :disabled="loading"
          @click="addPayableOrder"
        >{{ $t('fms_accounts_registration_accounts_bill.tian_jia_zhang_dan') }}</el-button>
      </div>
    </div>
    <custom-table
      class="bill-list"
      index
      :tableCode="tableCode"
      :data="data"
      :filterArr="newFilterArr"
      @filter="filterChange"
      @sort="sortChange"
      @row-click="onClickRow"
      :slots="['termNum', 'action']"
      max-height="350px"
    >
      <!-- 期数 -->
      <template
        slot="termNum"
        slot-scope="scope"
      >
        <div>{{ scope.row.termNum }}/{{ scope.row.totalTerm }}</div>
      </template>
      <template v-slot:action="scope">
        <span></span>
        <el-button
          v-if="curAuth.includes('del') && (paymentOrReceivable || `${scope.row.billType}` !== '19')"
          :disabled="loading"
          type="text"
          size="mini"
          @click.stop="del(scope)"
        >{{ $t('Common.com_delete') }}</el-button>
      </template>
    </custom-table>
    <accounts-add-account-dialog
      v-if="dialog1Visible"
      @close="dialog1Visible = false"
      :model="dialog1Model"
      @confirm="onConfirm"
      :paymentOrReceivable="paymentOrReceivable"
    ></accounts-add-account-dialog>
  </div>
</template>

<script>
/** 收款/付款-账单信息 */

import billMixin from './billMixin';
import accountsAddAccountDialog from './accounts_add_account_dialog';

export default {
  name: '',
  mixins: [billMixin],
  components: { accountsAddAccountDialog },
  props: {
    tableCode: {
      type: String,
      default: 'accounts_registration_bill'
    },
    // tips: [Boolean, String],
    // 当为true时，账单列表不可编辑
    isLockBill: {
      type: Boolean,
      default: false
    },
    // false-收款  true-付款
    paymentOrReceivable: {
      type: Boolean,
      default: false
    },
    loading: {
      type: Boolean,
      default: false
    },
  },
  computed: {
    total() {
      return this.data.reduce((total, item) => total + this.getPayTotal(item), 0);
    },
    newFilterArr() {
      if (this.filterArr && this.filterArr.length) {
        if (!this.curAuth.includes('addPayableOrder') || this.isLockBill) {
          return [...this.filterArr, 'action'];
        }
      }
      return this.filterArr;
    }
  },
  data() {
    return {
      fullAuth: ['del', 'addPayableOrder', 'copy'],
      showActionAuth: ['del'],
      defaultAuth: [],
      isRest: false,
      dialog1Visible: false,
      dialog1Model: {},
      firstItem: {}
    };
  },
  watch: {
    value(val) {
      if (val && val.length) {
        this.firstItem = val[0];
      }
    }
  },
  filters: {},
  directives: {},
  methods: {
    getPayTotal(item) {
      const { paymentAmount = 0 } = item;
      // 本期应收金额
      const total = paymentAmount;
      return total;
    },
    onConfirm(arr) {
      arr.forEach((item) => {
        item.depositFee = 0;
      });
      this.$emit('add', arr);
    },
    // 删除
    del(scope) {
      this.$emit('delete', scope.row);
    },
    addPayableOrder() {
      this.dialog1Model = {
        type: 'add',
        data: {
          ...this.firstItem,
          billTradeState: 0,
          filterBillIdList: this.data.map(item => item.billId)
        },
        selectedId: this.data.map(item => item.billId)
      };
      this.dialog1Visible = true;
    }
  },
  created() { },
  mounted() {
    this.firstItem = this.value[0];
  }
};
</script>

<style lang="scss">
.accounts-payable-bill {
  padding-bottom: 16px;
}
</style>
